import { useQuery } from '@tanstack/react-query';
import { getDailyCollection, getDelinquencyAnalysis } from '@/services/credit-worker.service';

const REFETCH_INTERVAL = 60_000;

export function useCollectionDashboard(date?: string) {
  const dailyQuery = useQuery({
    queryKey: ['collection', 'daily', date],
    queryFn: () => getDailyCollection(date),
    refetchInterval: REFETCH_INTERVAL,
  });

  const delinquencyQuery = useQuery({
    queryKey: ['collection', 'delinquency'],
    queryFn: () => getDelinquencyAnalysis(),
    refetchInterval: REFETCH_INTERVAL,
  });

  const isLoading = dailyQuery.isLoading || delinquencyQuery.isLoading;
  const isError = dailyQuery.isError || delinquencyQuery.isError;
  const error = dailyQuery.error ?? delinquencyQuery.error;

  function refetchAll() {
    void dailyQuery.refetch();
    void delinquencyQuery.refetch();
  }

  return {
    daily: dailyQuery.data?.data ?? null,
    delinquency: delinquencyQuery.data?.data ?? null,
    isLoading,
    isError,
    error,
    refetchAll,
  };
}
